import React, { forwardRef } from "react";
import * as S from "./styles";
export var Dropdown = forwardRef(function (e, a) {
  var t = e.items,
      r = e.label,
      l = e.name,
      n = e.value,
      c = e.className,
      o = e.hideLabel,
      m = e.onChange;
  return React.createElement(S.Wrapper, {
    hideLabel: o,
    className: c
  }, React.createElement(S.Label, {
    htmlFor: l
  }, r), React.createElement(S.SelectWrapper, null, React.createElement(S.Select, {
    onChange: function onChange(e) {
      m && m(e);
    },
    name: l,
    id: l,
    "data-testid": l,
    ref: a,
    value: n && n
  }, t.map(function (e) {
    return React.createElement(S.Option, {
      key: e.id,
      value: e.value
    }, e.value);
  })), React.createElement(S.DownArrow, null)));
});
export default Dropdown;